module.exports = __webpack_public_path__ + "static/media/medicine.406d1625.png";